import { INVITATION_CODE } from "~/common/constants";
import { generateQueryString } from "~/common/utils/generateQueryString";
import { env } from "~/providers/env";

export const generateInvitationLink = (invitationCode: string) => {
  const apiUrl = env.VITE_APP_URL;
  const URL = `${apiUrl}/signup/lead`;

  return generateQueryString(URL, {
    [INVITATION_CODE]: [invitationCode],
  });
};
